import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import AdvanceCruiseService from "../../../../services/reservations/AdvanceCruiseService";

export const REQUEST_GENERATE_ADVANCE_CRUISE_REPORT =
  "REQUEST_GENERATE_ADVANCE_CRUISE_REPORT";
export const GENERATE_ADVANCE_CRUISE_REPORT_SUCCESS =
  "GENERATE_ADVANCE_CRUISE_REPORT_SUCCESS";
export const GENERATE_ADVANCE_CRUISE_REPORT_ERROR =
  "GENERATE_ADVANCE_CRUISE_REPORT_ERROR";
export const INITIAL_STATE_ADVANCE_CRUISE_REPORT =
  "INITIAL_STATE_ADVANCE_CRUISE_REPORT";

function requestGenerateAdvanceCruiseReport() {
  return {
    type: REQUEST_GENERATE_ADVANCE_CRUISE_REPORT,
  };
}

function generateAdvanceCruiseReportSuccess(json) {
  return {
    type: GENERATE_ADVANCE_CRUISE_REPORT_SUCCESS,
    data: json,
  };
}

function generateAdvanceCruiseReportError(json) {
  return {
    type: GENERATE_ADVANCE_CRUISE_REPORT_ERROR,
    error: json.data,
  };
}

export function initialStateAdvanceCruiseReport() {
  return {
    type: INITIAL_STATE_ADVANCE_CRUISE_REPORT,
  };
}

export function generateAdvanceCruiseReport(yachtId, startDate, endDate) {
  return (dispatch) => {
    dispatch(requestGenerateAdvanceCruiseReport());
    return AdvanceCruiseService.getAdvanceCruisesReport(
      yachtId,
      startDate,
      endDate
    )
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", "AdvanceCruises.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          dispatch(generateAdvanceCruiseReportSuccess("Descarga completada"));
        } else if (response.data.code === 202) {
          updateLocalStorageToken(response.data.token);
          dispatch(generateAdvanceCruiseReport(yachtId, startDate, endDate));
        } else if (response.data.code === 498) {
          logOut();
        } else {
          dispatch(generateAdvanceCruiseReportError(response.data));
        }
      })
      .catch((error) => {
        dispatch(generateAdvanceCruiseReportError(error));
      });
  };
}

